<template>
  <content-container>
    <div class="service-unavailable">
      <img src="/assets/images/delete-warning.svg" class="image" alt="" />
      <h2 class="title">{{ $t('digitalServices.notAvailable.title') }}</h2>
      <p class="description" v-html="$t('digitalServices.notAvailable.description')"></p>
    </div>
  </content-container>
</template>

<script>
import ContentContainer from '@/components/common/main-layout/content-container'

export default {
  name: 'user-not-eligible',
  components: { ContentContainer }
}
</script>

<style scoped lang="scss">
.service-unavailable {
  padding: 160px 2rem 3.2rem;
  color: $text;
  text-align: center;

  @media (map_get($breakpoints, lg)) {
    padding-top: 160px;
  }

  .image {
    width: 80px;
    height: auto;
    display: inline-block;
    margin-bottom: 2.4rem;

    @media (map_get($breakpoints, sm)) {
      width: 112px;
    }
  }

  .title {
    font-size: 3.2rem;
    font-weight: normal;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.6rem;
    margin-bottom: 3.2rem;
  }
}
</style>
